module.exports = __webpack_public_path__ + "static/media/sell_take_order_help_8.e33c4e31.jpg";